/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import moment from "moment";

const options: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: false,
};

const dateOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

const timeOptions: Intl.DateTimeFormatOptions = {
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: false,
};

export const dollarFormat = (value: any, locale: any, currency: any) =>
  Intl.NumberFormat(locale, { style: "currency", currency }).format(value);

export const dateFormat = (locale: any, value: any) => {
  //runtime server all runing from docker which is UTC
  //Add moment to wrap around date string, the date string from response is
  //YYYY-DD-MM HH:mm:ss.sss , this is not an official supported format, Safari complains about this.
  //The official ISO8601 is YYYY-DD-MMTHH:mm:ss.sssZ, MomentJs handle this different date format string gracefully.
  const date = moment.utc(value).toDate();
  return Intl.DateTimeFormat(locale, options).format(date);
};

export const onlyDateFormat = (locale: any, value: any) => {
  const date = moment.utc(value).toDate();
  return Intl.DateTimeFormat(locale, dateOptions).format(date);
};

export const timeFormat = (locale: any, value: any) => {
  const date = moment.utc(value).toDate();
  return Intl.DateTimeFormat(locale, timeOptions).format(date);
};
